import axios from 'axios'
import { api } from './client'

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'
const API_URL = BASE_URL.endsWith('/') ? BASE_URL.slice(0, -1) : BASE_URL

export interface ContactFormData {
    name: string
    email: string
    subject: string
    message: string
}

export const contactService = {
    // Public endpoint, use raw axios
    async sendMessage(data: ContactFormData) {
        try {
            const response = await axios.post(`${API_URL}/contact/messages/`, data)
            return response.data
        } catch (error) {
            console.error('Error sending message:', error)
            throw error
        }
    },

    // Protected endpoints, use the 'api' client from client.ts
    async getMessages() {
        try {
            const response = await api.get('/contact/messages/')
            return response.data
        } catch (error) {
            console.error('Error fetching messages:', error)
            throw error
        }
    },

    async deleteMessage(id: number) {
        try {
            await api.delete(`/contact/messages/${id}/`)
        } catch (error) {
            console.error('Error deleting message:', error)
            throw error
        }
    },

    async updateMessageStatus(id: number, status: string) {
        try {
            const response = await api.patch(`/contact/messages/${id}/`, { status })
            return response.data
        } catch (error) {
            console.error('Error updating message status:', error)
            throw error
        }
    }
}
